import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import ModalDialog from '../../../../components/ModalDialog/ModalDialog.js';
import { AuditSites } from '../../actions/SiteTrackerActions';

const VENDOR_OPTIONS = [
	{ value: 'Nokia', label: 'Nokia' },
	{ value: 'Ericsson', label: 'Ericsson' }
];

const SiteTrackerAuditDialog = (props) => {
	const { open, onClose } = props;
	const dispatch = useDispatch();
	const userId = useSelector(state => state.session.user.id);
	const [vendor, setVendor] = useState('Nokia');

	const _onConfirmClick = () => {
		dispatch(AuditSites(userId, vendor));
		onClose();
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title="VMO2 Tracker Audit"
			confirmLabel="Submit"
			onConfirmClicked={_onConfirmClick}
			cancelLabel="Cancel"
			isDisabled={!vendor}
		>
			<div style={{ marginTop: '10px' }}>
				<FormControl fullWidth size="small">
					<InputLabel id="site-tracker-audit-vendor-label">Vendor</InputLabel>
					<Select
						labelId="site-tracker-audit-vendor-label"
						id="site-tracker-audit-vendor"
						value={vendor}
						label="Vendor"
						onChange={(event) => setVendor(event.target.value)}
					>
						{VENDOR_OPTIONS.map((option) => (
							<MenuItem key={option.value} value={option.value}>
								{option.label}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			</div>
		</ModalDialog>
	);
};

SiteTrackerAuditDialog.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool,
};

export default SiteTrackerAuditDialog;
